import { getUserAnalyticsDetailDefaultRoute } from "./analytics/userAnalyticsAccess"
import { getEmailReportingsDetailPageRoutes } from "@/modules/email-reportings/route"

export function getUsersRoutes() {
  return [
    {
      path: "/analytics/users",
      name: "users-analytics",
      component: () => import(/* webpackChunkName: "users-analytics" */ "./analytics/views/UsersAnalytics.vue"),
    },
    {
      path: "/analytics/users/reportings",
      name: "users-analytics-reportings",
      component: () => import(/* webpackChunkName: "users-analytics-reportings" */ "./analytics/views/UsersAnalyticsReportings.vue"),
      meta: {
        isDetailPageOutlet: true,
      },
      children: [...getEmailReportingsDetailPageRoutes("users-analytics-reportings", "details")],
    },
    {
      path: "/analytics/users/:userId",
      name: "user-analytics-detail-wrapper",
      component: () => import(/* webpackChunkName: "user-analytics-detail" */ "./analytics/views/UserAnalyticsDetailWrapper.vue"),
      children: [
        {
          path: "",
          redirect: (to: { params: Record<string, string | string[]> }) => {
            return getUserAnalyticsDetailDefaultRoute(to.params.userId)
          },
        },
        {
          path: "courses",
          name: "user-analytics-detail-courses",
          component: () => import(/* webpackChunkName: "user-analytics-detail-courses" */ "./analytics/views/UserAnalyticsCoursesOverview.vue"),
        },
        {
          path: "certificates",
          name: "user-analytics-detail-certificates",
          component: () => import(/* webpackChunkName: "user-analytics-detail-certificates" */ "./analytics/views/UserAnalyticsCertificatesList.vue"),
        },
        {
          path: "appointments",
          name: "user-analytics-detail-appointments",
          component: () => import(/* webpackChunkName: "user-analytics-detail-appointments" */ "./analytics/views/UserAnalyticsAppointmentsOverview.vue"),
        },
      ],
    },
    {
      path: "/usersnew",
      name: "usersnew",
      component: () => import(/* webpackChunkName: "users-list" */ "./views/UsersView.vue"),
    },
    {
      path: "/users",
      name: "users",
      component: () => import(/* webpackChunkName: "users-old-backend */ "./components/UserOld.vue"),
    },
    {
      path: "/user-roles",
      name: "user-roles",
      component: () => import(/* webpackChunkName: "user-roles-old-backend */ "./components/UserRolesOld.vue"),
    },
  ]
}
